import { StyledMenuDivider } from '../styled-components'

interface MenuDividerProps {
  hidden: boolean
}

const MenuDivider = ({ hidden }: MenuDividerProps) => {
  if (hidden) return null

  return <StyledMenuDivider role='separator' />
}

export default MenuDivider
